import { render, staticRenderFns } from "./invent.vue?vue&type=template&id=4d8ad436&"
import script from "./invent.js?vue&type=script&lang=js&"
export * from "./invent.js?vue&type=script&lang=js&"
import style0 from "./invent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports